import towns from './towns'

var states = []
var townsByState = {}

towns.forEach(town => {
  if(! townsByState[town.stateCode]) {
    townsByState[town.stateCode] = []
    states.push({
      code: town.stateCode,
      name: town.stateName
    })
  }
  townsByState[town.stateCode].push(town)
})

states.sort((s1, s2) => s1.name.localeCompare(s2.name, 'fi'))

export default {
  listStates() {
    return states
  },
  listTowns() {
    return towns
  },
  getStateByCode(code) {
    return states.find(state => state.code == code)
  },
  getTownByCode(code) {
    return towns.find(town => town.code == code)
  },
  listTownsForState(stateCode) {
    townsByState[stateCode].sort((t1, t2) => t1.name.localeCompare(t2.name, 'fi'))
    return townsByState[stateCode]
  }
}



// WEBPACK FOOTER //
// ./src/api/townService.js